var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.44 45.8098V44.1369C39.44 43.6582 39.1192 43.2606 38.6392 43.1809L35.0394 42.3835C34.7996 41.4282 34.3997 40.631 33.9197 39.7547L35.9199 36.6475C36.1597 36.2501 36.0796 35.7712 35.7598 35.373L33.8396 33.4608C33.5198 33.1423 32.9595 33.0625 32.5596 33.302L29.4397 35.2939C28.6399 34.815 27.7591 34.4967 26.8801 34.258L26.0794 30.673C26 30.1941 25.5994 29.8755 25.1192 29.8755H22.3196C21.8399 29.8755 21.4397 30.1941 21.3599 30.673L20.5598 34.258C19.6799 34.4965 18.7996 34.8957 17.9996 35.2939L14.8799 33.3017C14.3999 33.0625 13.9199 33.1423 13.5999 33.4608L11.5999 35.4527C11.2798 35.7712 11.1997 36.3292 11.4397 36.7275L13.4397 39.8351C12.96 40.631 12.6397 41.5081 12.3999 42.3835L8.79982 43.1809C8.31984 43.2606 7.99978 43.6582 7.99978 44.1371V45.8098H2V9.95866H45.9995V12.9859H9.99978C9.43995 12.9859 8.95974 13.4648 8.95974 14.0219C8.95997 14.5798 9.43995 15.0571 9.99978 15.0571H45.9995V45.9687H39.44V45.8098ZM27.9996 45.8098H19.4397C19.6799 43.6582 21.5198 41.9064 23.7593 41.9064C25.9199 41.9061 27.7591 43.6582 27.9996 45.8098ZM15.4397 39.2774L13.5999 36.2501L14.4798 35.373L17.4397 37.2055C17.7598 37.444 18.1597 37.444 18.4795 37.2055C19.4397 36.5684 20.4795 36.1695 21.5996 35.9309C21.9998 35.851 22.2398 35.5327 22.3196 35.2142L23.1197 31.7877H24.3196L25.1194 35.2142C25.1995 35.6124 25.52 35.851 25.8399 35.9309C26.9602 36.1695 27.9996 36.5686 28.9597 37.2055C29.2796 37.444 29.6795 37.444 30 37.2055L32.9595 35.373L33.8396 36.2501L31.9996 39.1974C31.7598 39.5159 31.7598 39.9142 31.9996 40.2334C32.6399 41.1887 33.0398 42.2247 33.2794 43.3397C33.3594 43.7379 33.6793 43.9774 33.9998 44.0565L37.4395 44.8536V45.7299H30C29.7596 42.4641 27.0396 39.8351 23.6799 39.8351C20.3196 39.8351 17.5996 42.4641 17.3597 45.7301L9.91993 45.7299V44.8536L13.3596 44.0565C13.76 43.9774 13.9998 43.6582 14.0798 43.3397C14.3196 42.2247 14.7998 41.1887 15.3597 40.2334C15.6797 39.9939 15.6795 39.5957 15.4397 39.2774ZM13.9998 1.99195V7.96737H2V1.99195H13.9998ZM45.9995 3.98412H26C25.4399 3.98412 24.9597 4.46147 24.9597 5.01921C24.9597 5.57717 25.4399 6.05517 26 6.05517H45.9995V7.96737H15.9996V1.99195H45.9995V3.98412ZM47.0398 0H1.03981C0.479982 0 0 0.477998 0 1.03596V46.8458C0 47.4035 0.479982 47.8809 1.03981 47.8809H8.55961C8.87967 48.0397 9.19973 48.0397 9.43995 47.8809H37.9197C38.2393 48.0397 38.5592 48.0397 38.7996 47.8809H46.9597C47.5198 47.8809 47.9998 47.4035 47.9998 46.8458L48 1.03596C48 0.477998 47.5198 0 47.0398 0Z",
    fill: "url(#paint0_linear_486_2077)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5198 19.9174H6.47998C6.23977 19.9174 5.99977 19.678 5.99977 19.4394C5.99977 19.2 6.23977 18.9614 6.47998 18.9614L23.5198 18.9612C23.7593 18.9612 23.9998 19.2 23.9998 19.4394C23.9998 19.678 23.7593 19.9174 23.5198 19.9174ZM23.5198 16.9692H6.47998C5.11988 16.9692 4 18.0849 4 19.4394C4 20.7937 5.11988 21.9087 6.47998 21.9087H23.5198C24.8797 21.9087 26 20.7937 26 19.4394C26 18.0849 24.8797 16.9692 23.5198 16.9692Z",
    fill: "url(#paint1_linear_486_2077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5198 25.8919H6.47998C6.23977 25.8919 5.99977 25.6533 5.99977 25.4147C5.99977 25.1753 6.23977 24.9359 6.47998 24.9359H23.5198C23.7593 24.9359 23.9998 25.1753 23.9998 25.4147C23.9998 25.6533 23.7593 25.8921 23.5198 25.8919ZM23.5198 22.9446H6.47998C5.11988 22.9446 4 24.0603 4 25.4147C4 26.7683 5.11988 27.884 6.47998 27.884H23.5198C24.8797 27.884 26 26.7683 26 25.4147C26 24.0603 24.8797 22.9446 23.5198 22.9446Z",
    fill: "url(#paint2_linear_486_2077)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03981 14.9783H7.03981C7.60009 14.9783 8.07962 14.5003 8.07962 13.9423C8.07962 13.3844 7.60009 12.9064 7.03981 12.9064H5.03981C4.47998 12.9064 4 13.3846 4 13.9423C4 14.5003 4.47998 14.9783 5.03981 14.9783Z",
    fill: "url(#paint3_linear_486_2077)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.98389H5.99977V5.97518H4V3.98389Z",
    fill: "url(#paint4_linear_486_2077)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03906 3.98389H9.03907V5.97518H7.03906V3.98389Z",
    fill: "url(#paint5_linear_486_2077)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.98389H12V5.97518H10V3.98389Z",
    fill: "url(#paint6_linear_486_2077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_2077",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_2077",
    x1: 15,
    y1: 16.9692,
    x2: 15,
    y2: 21.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_2077",
    x1: 15,
    y1: 22.9446,
    x2: 15,
    y2: 27.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_2077",
    x1: 6.03981,
    y1: 12.9064,
    x2: 6.03981,
    y2: 14.9783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_2077",
    x1: 4.99989,
    y1: 3.98389,
    x2: 4.99989,
    y2: 5.97518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_2077",
    x1: 8.03906,
    y1: 3.98389,
    x2: 8.03906,
    y2: 5.97518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_2077",
    x1: 11,
    y1: 3.98389,
    x2: 11,
    y2: 5.97518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.b0863e84b5708dddc2b4c977541691dd.svg";
export { ForwardRef as ReactComponent };